import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--allie-spacing-md);
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;

  @media (max-width: 768px) {
    gap: var(--allie-spacing-xl);
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--allie-spacing-md);
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: var(--allie-spacing-md);
  flex-wrap: wrap;

  ion-chip {
    font-size: 12px;
    margin: 0;
  }

  @media (max-width: 768px) {
    gap: var(--allie-spacing-md);
  }
`;

export const ContentGrid = styled.div`
  display: grid;
  gap: var(--allie-spacing-md);
  container-type: inline-size;
  container-name: report-view-grid;
`;
